import api from 'utils/api';
import { Privileges } from 'types/privileges';

const getFeatures = () => api.get<Privileges>('features');

export default getFeatures;
